import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { AcModel } from './ac.model';
import moment, { Moment } from 'moment';

export class PackageModel extends BaseModel implements Deserializable {

  // columns
  number: number;
  status: string;
  price: number;
  amount: number;
  used: number;
  name: string;
  activated_at?: Moment;
  finished_at?: Moment;
  valid_from?: Moment;
  valid_to?: Moment;

  billingStatus?: string;
  billingRemaining?: number;

  // relations
  acs: Array<AcModel>;

  deserialize(input: any): this {
    Object.assign(this, input);
    // acs
    let acs = null;
    if (this.acs !== null && this.acs !== undefined) {
      acs = [];
      this.acs.forEach((ac: any) => {
        acs.push(new AcModel().deserialize(ac));
      });
    }
    this.acs = acs;
    // used
    if (this.used === null || this.used === undefined) {
      this.used = 0;
    }
    // dates
    if (this.activated_at) {
      this.activated_at = moment(this.activated_at);
    }
    if (this.finished_at) {
      this.finished_at = moment(this.finished_at);
    }
    if (this.valid_from) {
      this.valid_from = moment(this.valid_from);
    }
    if (this.valid_to) {
      this.valid_to = moment(this.valid_to);
    }
    return this;
  }

  public isActive(): boolean {
    return this.status === 'active';
  }

}
